import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import {FormattedMessage, useIntl} from "react-intl";
import messages from "./messages";

const SettingTheScene = () => {
  const { formatMessage } = useIntl()

  let { topicId } = useParams()

  return (
    <React.Fragment>
      <div className="font-medium text-4xl">
        <FormattedMessage {...messages.settingTheScene}/>
      </div>

      <div className="text-gray-700 w-2/3">
        <FormattedMessage {...messages.goodImpression}/>
      </div>

      <div className="flex mt-12">
        <div>
          <div className="block w-32 h-32 bg-gray-100 border border-dashed border-gray-400 flex items-center justify-center hover:bg-gray-200 transition duration-200 cursor-pointer">
            <i className="fa fa-plus text-gray-600" />
          </div>
        </div>
        <div className="ml-4">
          <p><FormattedMessage {...messages.profilePicture}/> *</p>
          <p className="text-sm font-light text-gray-600 w-2/3"><FormattedMessage {...messages.profilePicture}/></p>
          <button className="border border-gray-400 px-4 py-2 mt-4 text-sm">
            <i className="fa fa-plus" /> <FormattedMessage {...messages.selectFile}/>
          </button>
        </div>
      </div>

      <fieldset className="block mt-12">
        <p className="py-4"><FormattedMessage {...messages.name}/> *</p>
        <input type="text" placeholder={formatMessage(messages.enterName)} className="w-full border border-gray-400 p-4 focus:border-primary transition duration-200" />
      </fieldset>

      <fieldset className="block mt-12">
        <p className="py-4"><FormattedMessage {...messages.shortDescription}/> *</p>
        <textarea placeholder={formatMessage(messages.enterDescription)} className="w-full resize-y border border-gray-400 p-4 focus:border-primary transition duration-200" />
        <p className="text-xs py-2 font-light text-gray-600"><FormattedMessage {...messages.enterDescriptionInformation}/></p>
      </fieldset>
    </React.Fragment>
  )
}

export default SettingTheScene

